import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { exchangeSession } = useUserAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setError("Keine Session-ID erhalten. Bitte erneut versuchen.");
      return;
    }

    (async () => {
      const ok = await exchangeSession(sessionId);
      if (ok) {
        navigate("/", { replace: true });
      } else {
        setError("Anmeldung fehlgeschlagen. Bitte erneut versuchen.");
      }
    })();
  }, [exchangeSession, navigate]);

  if (error) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-[hsl(var(--cream))]">
        <div className="text-center p-8">
          <p className="text-red-600 text-lg mb-4">{error}</p>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-2 rounded-lg bg-[hsl(var(--primary))] text-white"
          >
            Zur Startseite
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-[hsl(var(--cream))]">
      <div className="text-center">
        <Loader2 size={40} className="mx-auto mb-4 animate-spin text-[hsl(var(--primary))]" />
        <p className="text-[hsl(var(--foreground))] text-lg">Anmeldung wird abgeschlossen...</p>
      </div>
    </main>
  );
}
